var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2002 4.5L12 6.2998H19.2002C20.1945 6.29991 20.9998 7.10535 21 8.09961V17.0996C21 18.094 20.1946 18.9003 19.2002 18.9004H4.7998C3.80539 18.9003 3 18.094 3 17.0996L3.00879 6.2998C3.00889 5.30546 3.80546 4.50011 4.7998 4.5H10.2002ZM4.7998 8.09961V17.0996H19.2002V8.09961H4.7998Z",
    fill: "#646A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderLight);
export default __webpack_public_path__ + "static/media/Folder-Light.c8ee47830c49a21a3fb7325d6a8193a2.svg";
export { ForwardRef as ReactComponent };